
import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Badge } from "@/components/ui/badge";
import { Tag } from "lucide-react";
import PhoneNumbersSection from "@/components/account/PhoneNumbersSection";

const Account: React.FC = () => {
  const { profile } = useAuth();
  
  // Format membership level for display
  const formatMembershipLevel = (level: string | undefined): string => {
    if (!level) return 'Free Plan';
    
    // Convert snake_case to Title Case
    return level
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-heading font-bold text-primary-700 mb-6">My Account</h1>
      
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">Account Information</h2>
        
        <div className="space-y-4">
          <div>
            <p className="text-sm text-gray-500">Name</p>
            <p className="text-gray-800 font-medium">{profile?.name || 'Not set'}</p>
          </div>
          
          <div>
            <p className="text-sm text-gray-500">Email</p>
            <p className="text-gray-800 font-medium">{profile?.email || 'Not set'}</p>
          </div>
          
          <div>
            <p className="text-sm text-gray-500">Membership</p>
            <div className="flex items-center gap-2 mt-1">
              <Badge variant={profile?.active_membership_slug?.includes('premium') ? "outline" : "outline"} 
                    className="flex items-center gap-1">
                <Tag size={12} />
                <span>{formatMembershipLevel(profile?.active_membership_slug)}</span>
              </Badge>
            </div>
          </div>
      </div>

      <PhoneNumbersSection />
    </div>
    </div>
  );
};

export default Account;
